/* eslint-disable no-underscore-dangle -- the __dhlConfig variable is named this way */
// @ts-ignore
import localConfig from '../configuration/local.json'
import { AppConfiguration } from '../configuration/AppConfiguration'

type ConfigVars = AppConfiguration & {
  CSP_NONCE: string
  VERSION: string
}

declare global {
  interface Window {
    __dhlConfig: ConfigVars
  }
}

export const getConfig = () => {
  const config: ConfigVars = process.env.NODE_ENV === 'development' ? localConfig : window.__dhlConfig

  return {
    apiGatewayHost: config.API_GATEWAY_HOST,
    basePath: config.BASE_PATH,
    captchaV2SiteKey: config.CAPTCHA_V2_SITE_KEY,
    version: config.VERSION,
    cspNonce: config.CSP_NONCE,
  }
}

export const config = getConfig()
